import {AfterViewInit, Component,  ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
import {MaterialInstance, MaterialService} from "../shared/classes/material.service";
import {StreamsService}  from "../shared/services/streams.service";
import {StreamProject} from "../shared/interfaces";
import {switchMap, map, delay} from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
import {SocketStreamsControl, socketEvents} from '../shared/services/sockets'
import {VideoPlayerComponent} from '../shared/components/video-player/video-player.component'


///getToken 
//streaming

@Component({
  selector: 'app-video-page',
  templateUrl: './video-page.component.html',
  styleUrls: ['./video-page.component.scss']
})
export class VideoPageComponent implements OnInit, OnDestroy{

 

  video: StreamProject
 stream$:Observable<StreamProject>
  



   constructor(
    public streamsService: StreamsService,
    public route:  ActivatedRoute  ){
 
   }

  ngOnInit() { 
   

    this.stream$ = this.route.params.pipe(
      switchMap((params: Params)=>{
        
        return this.streamsService.getVideoById(params['id']).pipe(
          map((video: any)=>{

            
            this.video = video
            return video
          })
        )
      })
    )
 
  }

   ngOnDestroy() { 
    
   }
 
  
}
